module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_7042.de46f6dd.png";